/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RentRollColumns {
    RENT_ROLL_AGGREGATION_BED_BATH = 'rent_roll_aggregation_bed_bath',
    RENT_ROLL_AGGREGATION_BED_BATH_SQFT = 'rent_roll_aggregation_bed_bath_sqft',
    RENT_ROLL_AGGREGATION_FLOORPLAN = 'rent_roll_aggregation_floorplan',
    RENT_ROLL_FLOORPLAN_NAME = 'rent_roll_floorplan_name',
    RENT_ROLL_BED = 'rent_roll_bed',
    RENT_ROLL_BATH = 'rent_roll_bath',
    RENT_ROLL_PARTIAL_BATH = 'rent_roll_partial_bath',
    RENT_ROLL_ASKING_RENT = 'rent_roll_asking_rent',
    RENT_ROLL_IN_PLACE_RENT = 'rent_roll_in_place_rent',
    RENT_ROLL_ESTIMATED_UNITS = 'rent_roll_estimated_units',
}
